<template lang="pug">
  .type-detail(:class="color" @mouseover="handleMouseOver" @click="handleClick")
    canvas(ref="detail" resize="true")
</template>

<script>
/* eslint-disable */
import { mapGetters, mapActions } from "vuex";
import paper from "paper";
import PressKey from "@/components/svg/PressKey.vue";

export default {
  name: "FontSlider",

  props: ["color"],

  data() {
    return {
      circle: {},
      shape: {},
      glyphTexts: [],
      xOffsets: [0],
      textCircle: {},
      letterA: {},
      letterB: {},
      letterC: {},
      letterAClipped: {},
      letterBClipped: {},
      letterCClipped: {},
      bold: {},
      regular: {},
      italic: {},
      width: 0,
      height: 0,
      circleVisibility: false,
    };
  },

  created() {
    window.addEventListener("resize", this.handleResize);
  },

  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },

  computed: {
    ...mapGetters({
      activeLetter: 'getActiveLetter',
      getCircleVisibility: 'getCircleVisibility',
      getCursor: 'getCursor'
    })
  },

  methods: {
    ...mapActions({
      setActiveLetter: 'setActiveLetter',
      setCursorId: 'setCursor',
      setCircleVisibility: 'setCircleVisibility'
    }),

    handleClick() {
      this.setActiveLetter(this.genLetter())
    },

    handleMouse(e) {
      this.setCursorId(parseInt(e));
    },

    handleMouseOver(e) {
      this.setCircleVisibility(true)
    },

    handleResize() {
      this.width = window.innerWidth;
      this.height = window.innerHeight;
      const offset = this.width * .33
      const h = this.height / 2 - 50;
      const h_clipped = this.height / 2;
      const w = this.width / 2;
      const fSizeN = this.width * 0.3472222222
      const fSizeC = this.width * 0.4513888889

      if (window.paper) {
        this.letterA.position = new Point(w - offset, h)
        this.letterB.position = new Point(w, h)
        this.letterC.position = new Point(w + offset, h)

        this.letterA.fontSize = fSizeN
        this.letterB.fontSize = fSizeN
        this.letterC.fontSize = fSizeN

        this.letterAClipped.position = new Point(w - offset, h)
        this.letterBClipped.position = new Point(w, h)
        this.letterCClipped.position = new Point(w + offset, h)

        this.letterAClipped.fontSize = fSizeC
        this.letterBClipped.fontSize = fSizeC
        this.letterCClipped.fontSize = fSizeC

        this.italic.position = new Point(w - offset, h + 340)
        this.regular.position = new Point(w, h + 340)
        this.bold.position = new Point(w + offset, h + 340)

        this.shape.bounds.width = this.width
      }
    },

    genLetter() {
      let l = Math.random().toString(36)
      return l[l.length - 1]
    },

    // createAlignedText(str, style) {
    //   if (str && str.length > 0 && this.textCircle) {
    //     // create PointText object for each glyph
    //     for (let i = 0; i < str.length; i++) {
    //       this.glyphTexts[i] = this.createPointText(str.substring(i, i+1), style);
    //       this.glyphTexts[i].justification = "center";
    //     }
    //     // for each glyph find center xOffset
    //     for (let i = 1; i < str.length; i++) {
    //       let pairText = this.createPointText(str.substring(i - 1, i + 1), style);
    //       pairText.remove();
    //       this.xOffsets[i] = this.xOffsets[i - 1] + pairText.bounds.width - this.glyphTexts[i - 1].bounds.width / 2 - this.glyphTexts[i].bounds.width / 2;
    //     }
    //   }

    //   for (let i = 0; i < str.length; i++) {
    //     let centerOffs = this.xOffsets[i];
    //     if (this.textCircle.length < centerOffs) {
    //       if (this.textCircle.closed) {
    //           centerOffs = centerOffs % path.length;
    //       }  else {
    //           centerOffs = undefined;
    //       }
    //     }
    //     if (centerOffs === undefined) {
    //       this.glyphTexts[i].remove();
    //     } else {
    //       let pathPoint = this.textCircle.getPointAt(centerOffs);
    //       this.glyphTexts[i].point = pathPoint;
    //       let tan = this.textCircle.getTangentAt(centerOffs);
    //       this.glyphTexts[i].rotate(tan.angle, pathPoint);
    //     }
    //   }
    // },

    // moveAlignedText(str) {
    //     // set point for each glyph and rotate glyph aorund the point
    //     for (let i = 0; i < str.length; i++) {
    //       let centerOffs = this.xOffsets[i];
    //       if (this.textCircle.length < centerOffs) {
    //         if (this.textCircle.closed) {
    //             centerOffs = centerOffs % path.length;
    //         }  else {
    //             centerOffs = undefined;
    //         }
    //       }
    //       if (centerOffs === undefined) {
    //         this.glyphTexts[i].remove();
    //       } else {
    //         let pathPoint = this.textCircle.getPointAt(centerOffs);
    //         this.glyphTexts[i].point = pathPoint;
    //       }
    //     }
    // },

    // createPointText(str, style) {
    //   const text = new PointText();
    //   text.content = str;
    //   if (style) {
    //     if (style.font) text.font = style.font;
    //     if (style.fontFamily) text.fontFamily = style.fontFamily;
    //     if (style.fontSize) text.fontSize = style.fontSize;
    //     if (style.fontWeight) text.fontWeight = style.fontWeight;
    //     if (style.fillColor) text.fillColor = style.fillColor;
    //   }
    //   return text;
    // },

    initPaper() {
      paper.install(window);
      paper.setup(this.$refs.detail);
      paper.settings.handleSize = 1;
      paper.settings.hitTolerance = 4;
    },

    initCircleMask() {
      const tool = new Tool();
      this.circle = new Path.Circle(new Point(100, 70), 200);
      // this.textCircle = new Path.Circle(new Point(100, 70), 210);
      this.circle.strokeWidth = null;
      this.circle.strokeColor = null;
      // const style = {
      //   fontSize: 32,
      //   fillColor: '#FFF',
      //   fontFamily: "Courier New",
      //   fontWeight: "bold"
      // }
      // const string = "         PRESS YOUR KEYBORD"
      // this.createAlignedText(string, style);

      tool.onMouseMove = e => {
        this.circle.position = e.point;
        // this.textCircle.position = e.point;
        // this.moveAlignedText(string, style);
      };

      const offset = this.width * .33
      const h = this.height / 2 + 130;
      const w = this.width / 2;

      this.letterAClipped = new PointText(new Point(w - offset, h));
      this.letterBClipped = new PointText(new Point(w, h));
      this.letterCClipped = new PointText(new Point(w + offset, h));

      this.italic = new PointText(new Point(w - offset, h + 170));
      this.regular = new PointText(new Point(w - 35, h + 170));
      this.bold = new PointText(new Point(w + offset, h + 170));

      this.italic.content = 'Italic';
      this.bold.content = 'Bold';
      this.regular.content = 'Regular';

      this.italic.fontSize = '22px';
      this.bold.fontSize = '22px';
      this.regular.fontSize = '22px';

      this.italic.fillColor = '#FFF';
      this.bold.fillColor = '#FFF';
      this.regular.fillColor = '#FFF';

      this.italic.fontFamily = "Redaction";
      this.bold.fontFamily = "Redaction";
      this.regular.fontFamily = "Redaction";

      const from = new Point(0, 0);
      const to = new Point(this.width, this.height * 1.2);
      this.shape = new Shape.Rectangle(from, to);
      this.shape.fillColor = '#FFF';

      let group = new Group(this.circle, this.shape, this.letterAClipped, this.letterBClipped, this.letterCClipped)
      group.clipped = true;

      this.letterAClipped.fontFamily = "Redaction";
      this.letterBClipped.fontFamily = "Redaction";
      this.letterCClipped.fontFamily = "Redaction";

      this.letterCClipped.fontWeight = "bold";
      this.letterAClipped.fontWeight = "italic";

      this.letterAClipped.fillColor = "#000";
      this.letterBClipped.fillColor = "#000";
      this.letterCClipped.fillColor = "#000";

      this.letterAClipped.content = "s";
      this.letterBClipped.content = "s";
      this.letterCClipped.content = "s";

      this.letterAClipped.fontSize = "650px";
      this.letterBClipped.fontSize = "650px";
      this.letterCClipped.fontSize = "650px";

      this.letterAClipped.justification = "center";
      this.letterBClipped.justification = "center";
      this.letterCClipped.justification = "center";
    },

    initSizes() {
      this.width = window.innerWidth;
      this.height = window.innerHeight;
    },

    renderLetters() {
      const offset = this.width * .33
      const h = this.height / 2 + 100;
      const w = this.width / 2;

      this.letterA = new PointText(new Point(w - offset, h));
      this.letterB = new PointText(new Point(w, h));
      this.letterC = new PointText(new Point(w + offset, h));

      this.letterA.fontFamily = "Redaction";
      this.letterB.fontFamily = "Redaction";
      this.letterC.fontFamily = "Redaction";

      this.letterC.fontWeight = "bold";
      this.letterA.fontWeight = "italic";

      this.letterA.fillColor = "#FFF";
      this.letterB.fillColor = "#FFF";
      this.letterC.fillColor = "#FFF";

      this.letterA.content = "s";
      this.letterB.content = "s";
      this.letterC.content = "s";

      this.letterA.fontSize = "500px";
      this.letterB.fontSize = "500px";
      this.letterC.fontSize = "500px";

      this.letterA.justification = "center";
      this.letterB.justification = "center";
      this.letterC.justification = "center";
    }
  },

  mounted() {
    this.initSizes();
    this.initPaper();
    this.renderLetters();
    this.initCircleMask();
  },

  watch: {
    activeLetter() {
      if (this.activeLetter !== 'm') {
        this.letterA.content = this.activeLetter;
        this.letterB.content = this.activeLetter;
        this.letterC.content = this.activeLetter;
        this.letterAClipped.content = this.activeLetter;
        this.letterBClipped.content = this.activeLetter;
        this.letterCClipped.content = this.activeLetter;
      }
    },

    getCursor() {
      this.shape.fillColor = !this.getCursor ? "#FFF" : "#000"
    }
  }
};
</script>

<style lang="sass">
@import '@/styles/_variables.sass'
.type-detail
  width: 100vw
  height: 110vh
  align-items: center
  justify-content: center
  position: relative
  cursor: none
  display: none
  @media only screen and (min-width: $m)
    display: flex
  canvas
    width: 100%
    height: 100%
  h3
    font-size: 2.2rem
    user-select: none
    line-height: 2.3rem
    position: absolute
    bottom: 30vh
    &.ff-1
      left: 13.5vw
    &.ff-2
    &.ff-3
      right: 9.5vw
</style>
